import { PHISHING_USER_STATUS } from '../../domain/domainCodes.js'
/** Legacy strings for صياد — Locale/Resources.ar.resx and Admin/*. */

const shared = {
  editor: 'محرر', // Awareness.Editor
  addNew: 'إضافة جديدة', // Resources.addNew
  export: 'تحميل', // Resources.Export
  import: 'استيراد', // Resources.Import
  close: 'إغلاق',
  active: 'نشط', // Resources.IsActive
  inactive: 'غير مفعلة', // Resources.InActive
  edit: 'تعديل', // Resources.Edit
  delete: 'حذف', // Resources.Delete
}

export const templatesStrings = {
  actionFailed: 'تعذر إتمام العملية',
  /* الفرز يعيد ترتيب صفوف هذه الصفحة. نقطة النهاية ترتّب حسب آخر تحديث
     وتقسّم الصفحات قبل الترتيب، فلا يمكن طلب صفحة بترتيب آخر. */
  sortScope: 'الترتيب يطبّق على القوالب المعروضة في هذه الصفحة.',
  imported: 'تم استيراد القوالب بنجاح',
  importNote: 'الملف المضغوط هو ما تُصدّره هذه الشاشة: مجلد لكل قالب بداخله details.json. القوالب التي يتطابق اسمها مع قالب موجود لا تُستورد.',
  ...shared,
  title: 'قوالب الإصطياد', // Resources.Phishing_Templates

  columns: {
    name: 'الإسم', // Resources.Name
    language: 'اللغة', // Resources.Language
    // Renamed: the column heads a badge that already says `سهل / متوسط / صعب`
    // and a `المحتوى` beside it; the full phrases only widened the table.
    difficulty: 'المستوى', // Resources.DifficultyLevel
    payloadType: 'المحتوى', // Resources.PayloadType
    status: 'نشط', // Resources.IsActive
    /* The legacy heads these three `صورة مصغرة للبريد`, `صورة مصغرة لصفحة
       الهبوط` and `صورة مصغرة لصفحة ما بعد الإصطياد` — thirty characters to
       label a picture that is already a picture of the thing. The full names
       stay on the preview sheet, where they are read once. */
    emailImage: 'البريد', // Resources.EmailContentImage
    landingImage: 'صفحة الهبوط', // Resources.LandingPageContentImage
    afterImage: 'ما بعد الإصطياد', // Resources.AfterPhishingImage
  },

  templateImages: 'صور القالب', // Resources.TemplateImages

  /** The three stored screenshots, by their full legacy names. */
  surfaces: {
    email: 'صورة مصغرة للبريد', // Resources.EmailContentImage
    landing: 'صورة مصغرة لصفحة الهبوط', // Resources.LandingPageContentImage
    after: 'صورة مصغرة لصفحة ما بعد الإصطياد', // Resources.AfterPhishingImage
  },

  /** The same three on the preview switch, where three full names do not fit. */
  surfaceTabs: { email: 'البريد', landing: 'صفحة الهبوط', after: 'ما بعد الإصطياد' },

  surfaceNote: 'معاينة مبنية على بيانات القالب، وتُستبدل بالصورة المرفوعة عند حفظها.',

  /* The language is a two-letter tag in the table — a whole `اللغة الإنجليزية`
     per row said, at length, the one bit of information the column exists for.
     The full names stay for the form, where there is room to be explicit. */
  languages: {
    ar: 'AR',
    en: 'EN',
    arFull: 'اللغة العربية', // Resources.Arabic
    enFull: 'اللغة الإنجليزية', // Resources.English
  },

  /** The template form — every label already exists above. */
  form: {
    title: 'قالب الإصطياد', // Resources.Phishing_Templates (singular subject)
    category: 'التصنيف', // Resources.Category
    /* A placeholder that repeats its own label says nothing twice. */
    categoryPlaceholder: 'اختر التصنيف',
    save: 'حفظ',
    saved: 'تم حفظ القالب بنجاح',
    required: 'الحقل مطلوب',

    /* The four steps the legacy's own template wizard uses —
       Views/PhishingTemplates/Index.cshtml. */
    steps: {
      identity: 'بيانات القالب',
      email: 'البريد',
      landing: 'صفحة الهبوط', // Resources.LandingPage
      after: 'ما بعد الإصطياد',
    },
    stepHints: {
      identity: 'التصنيف والاسم والمستوى واللغة',
      email: 'الموضوع والمحتوى والمرفقات',
      landing: 'الصفحة التي يصل إليها من ضغط الرابط',
      after: 'ما يراه بعد أن يقع في الإصطياد',
    },

    subject: 'الموضوع', // Resources.Subject
    thumbnail: 'صورة مصغّرة للمحتوى', // Resources.Content_Thumbnail
    body: 'محتوى البريد', // Resources.Body
    richText: 'نص منسق', // Resources.RichText
    attachments: 'رفع مرفقات البريد الإلكتروني', // Resources.UploadEmailAttachments
    trackingImage: 'تتبع الصورة', // Resources.TrackingImage
    landingPage: 'صفحة الهبوط', // Resources.LandingPage
    captureData: 'الإحتفاظ بالبيانات', // Resources.CaptureSubmittedData
    capturePasswords: 'الإحتفاظ بكلمات المرور', // Resources.CapturePasswords
    redirectToUrl: 'إعادة توجيه الي رابط', // Resources.RedirectToUrl
    redirectUrl: 'الإنتقال الي الرابط', // Resources.RedirectUrl
    redirectPage: 'محتوى صفحة ما بعد الوقوع في الإصطياد', // Resources.RedirectPage
    isActive: 'نشط', // Resources.IsActive
  },

  /** PhishingCampaignDifficultyLevel — Easy = 0, Normal = 1, Hard = 2. */
  difficulties: { 0: 'سهل', 1: 'متوسط', 2: 'صعب' },

  /** PhishingCampaignPayloadType — Website = 0, Attachment = 1, InformationRequest = 2. */
  payloads: { 0: 'موقع إصطياد', 1: 'مرفقات خبيثة', 2: 'طلب معلومات' },

  /**
   * The content editor behind كتابة المحتوى.
   *
   * The legacy authors a template body in a plain textarea of raw HTML with no
   * preview and no way to insert a merge field except by typing it exactly.
   */
  content: {
    title: 'محتوى القالب',
    subject: 'عنوان الرسالة',
    tabs: { compose: 'تحرير', source: 'HTML', preview: 'معاينة' },
    tokens: 'حقول الدمج',
    tokenHint: 'تُستبدل هذه الحقول ببيانات المستلم عند الإرسال.',
    bold: 'عريض',
    italic: 'مائل',
    underline: 'تسطير',
    heading: 'عنوان',
    bullets: 'قائمة',
    link: 'رابط',
    linkPrompt: 'الرابط',
    clear: 'إزالة التنسيق',
    save: 'حفظ',
    saved: 'تمت العملية بنجاح',
  },

  /** The merge fields the campaign engine substitutes at send time. */
  tokenList: [
    { token: '{{name}}', label: 'اسم المستلم' },
    { token: '{{email}}', label: 'البريد الإلكتروني' },
    { token: '{{department}}', label: 'الإدارة' },
    { token: '{{link}}', label: 'رابط الحملة' },
    { token: '{{date}}', label: 'التاريخ' },
  ],

  deleteConfirm: 'هل تريد حذف هذا القالب؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
}

export const campaignsStrings = {
  ...shared,
  title: 'حملات الإصطياد', // Resources.PhishingCampaigns
  importTitle: 'إستيراد البيانات من نظام الإصطياد القديم', // Resources.ImportOldPhishingSystemData
  importHint: 'رفع ملف قاعدة البيانات .db', // Resources.UploadDBFile
  from: 'من', // Resources.Date_From
  to: 'إلي', // Resources.Date_To
  report: 'التقرير', // Resources.Report

  saved: 'تم حفظ الحملة بنجاح',
  copied: 'تم نسخ الحملة بنجاح',
  actionFailed: 'تعذر إتمام العملية',

  /** No status is stored — these four are derived from active / started / finished. */
  states: {
    scheduled: 'مجدولة',
    running: 'جارية',
    finished: 'منتهية',
    inactive: 'معطلة',
  },

  disableTitle: 'إيقاف هذه الحملة؟',
  activateTitle: 'تشغيل هذه الحملة؟',
  disableConfirm: 'لن تُرسل هذه الحملة ولن تُحتسب نتائجها بعد الآن.',
  activateConfirm: 'ستعود هذه الحملة للعمل حسب تواريخها.',
  deleteWarning: 'سيُحذف معها سجل المستخدمين وكل النتائج المسجلة، ولا يمكن التراجع.',

  columns: {
    name: 'الإسم', // Resources.Name
    period: 'الفترة', // Resources.Period
    sent: 'تم الإرسال', // Resources.EmailSent
    opened: 'فتح البريد الإلكتروني', // Resources.EmailOpened
    clicked: 'فتح الرابط', // Resources.LinkClicked
    submitted: 'ادخل بيانات', // Resources.DataSubmitted
    reported: 'تم التبليغ', // Resources.Reported
    status: 'الحاله', // Resources.Status
  },

  row: {
    report: 'تقرير الإصطياد', // Resources.PhishingReport
    notifications: 'الإشعارات', // Resources.Notifications
    copy: 'نسخ', // Resources.Copy
    activate: 'تفعيل', // Resources.Activate
    disable: 'تعطيل', // Resources.Disable
  },

  /**
   * The إضافة جديدة campaign form — Views/PhishingCampaigns/Index.cshtml
   * `#edit_modal`. One modal, not a wizard; every label below is the legacy's.
   */
  form: {
    /* Section headings, and the four placeholders that used to repeat their own
       labels back at the reader. Neither exists in the legacy, which is one
       flat column of ten controls. */
    message: 'الرسالة والوجهة',
    timing: 'التوقيت',
    audience: 'المستهدفون',
    templatePlaceholder: 'اختر القالب',
    urlPlaceholder: 'اختر الرابط',
    senderPlaceholder: 'اختر بريد المرسل',
    programPlaceholder: 'بدون إدخال تلقائي',
    name: 'الإسم', // Resources.Name
    template: 'قالب الحملة', // Resources.CampaignTemplate
    url: 'الرابط', // Resources.Url
    sender: 'بريد المرسل', // Resources.SenderEmail
    startDate: 'تاريخ البداية', // Resources.StartDate
    endDate: 'تاريخ النهاية', // Resources.EndDate
    schedule: 'جدولة الإيميلات', // Resources.SendEmailsBy
    groups: 'الإدارات', // Resources.Groups
    selectAll: 'تحديد الكل', // Resources.SelectAll
    filter: 'تصفية', // Resources.Filter
    program: 'ادخال تلقائي في برنامج التدريبي', // Resources.AutoEnrollProgram
    active: 'نشط', // Resources.IsActive
    save: 'حفظ', // Resources.Save
    required: 'الحقل مطلوب',
    schedulingHint: 'يحدد متى تُرسل رسائل الحملة. اتركه فارغاً لإرسالها فور بدء الحملة.',
  },

  deleteConfirm: 'هل تريد حذف هذه الحملة؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
}

export const phishingSettingsStrings = {
  ...shared,
  title: 'الإعدادات', // Resources.Settings
  subtitle: 'صياد', // Resources.Phishing

  actionFailed: 'تعذر إتمام العملية',
  saved: 'تم الحفظ بنجاح',
  save: 'حفظ',
  required: 'الحقل مطلوب',

  /** The settings tab — the loose settings the legacy keeps under إعدادات الإصطياد. */
  settings: {
    engine: 'محرك الإصطياد',
    engineHint: 'تشغيل إرسال حملات الإصطياد ومتابعة أحداثها',
    intervalHint: 'بصيغة ساعات:دقائق:ثوانٍ — مثال 00:05:00',
    phishingEnabled: 'تفعيل الإصطياد',
    phishingInterval: 'الفاصل الزمني لخدمة الإصطياد',
    listener: 'متابعة بريد البلاغات',
    listenerHint: 'قراءة صندوق البريد الذي يُبلّغ إليه المستخدمون عن الرسائل المشبوهة',
    listenerEnabled: 'تفعيل متابعة البريد',
    listenerInterval: 'الفاصل الزمني لخدمة البريد',
    url: 'رابط خدمة الإصطياد',
    urlHint: 'العنوان الذي تُفتح منه صفحات الإصطياد وتُحتسب عليه الأحداث',
    skipHeaders: 'ترويسات يتم تجاهلها',
    skipHeadersHint: 'طلبات تحمل أي من هذه الترويسات لا تُحتسب — تُستخدم لتجاهل فحص أنظمة الحماية',
    skipHeadersAdd: 'إضافة ترويسة',
    skipHeadersEmpty: 'لا توجد ترويسات مُتجاهَلة',
    outlook: 'إضافة أوتلوك',
    outlookHint: 'كيف يُبلّغ المستخدم عن رسالة مشبوهة من داخل أوتلوك',
    outlookType: 'نوع الإضافة',
    outlookMethod: 'طريقة التبليغ',
    outlookEmail: 'بريد استقبال البلاغات',
    outlookDelete: 'حذف الرسالة بعد التبليغ',
    outlookNote: 'لا يمكن إلغاء اختيار طريقة التبليغ أو الحذف بعد التبليغ بعد ضبطهما — الواجهة البرمجية تتجاهل القيمة الفارغة.',
  },

  categoryForm: {
    add: 'تصنيف جديد',
    edit: 'تعديل التصنيف',
    enabled: 'هذا التصنيف مفعل',
    empty: 'لا توجد تصنيفات بعد',
    deleteConfirm: 'هل تريد حذف هذا التصنيف؟',
  },

  domainForm: {
    add: 'رابط جديد',
    edit: 'تعديل الرابط',
    empty: 'لا توجد روابط بعد',
    deleteConfirm: 'هل تريد حذف هذا الرابط؟',
    imported: 'تم استيراد الروابط بنجاح',
    importNote: 'ملف إكسل يحتوي على اسم الرابط وعنوانه.',
  },

  /** جهات الإرسال — إعدادات ارسال البريد. */
  smtpForm: {
    add: 'جهة إرسال جديدة',
    edit: 'تعديل جهة الإرسال',
    empty: 'لا توجد جهات إرسال بعد',
    deleteConfirm: 'هل تريد حذف جهة الإرسال هذه؟',
    imported: 'تم استيراد جهات الإرسال بنجاح',
    importNote: 'ملف إكسل بالأعمدة: الإسم، بريد المرسل، المستضيف، رقم المنفذ، اسم المستخدم، كلمة المرور، طريقة الإتصال، نشط، إسم الإعداد، عنوان المرسل الظاهر، التحقق من شهادة الخادم. تُطابق الصفوف بالإسم، وكلمة المرور الفارغة تُبقي المحفوظة.',

    name: 'إسم جهة الارسال',
    nameHint: 'الاسم الذي يظهر للمستقبِل في خانة المرسل',
    settingName: 'إسم الإعداد',
    settingNameHint: 'اسم داخلي للتمييز بين الإعدادات فقط، ولا يظهر للمستقبِل',
    from: 'بريد المرسل',
    fromHint: 'العنوان المستخدم فعليًا في الإرسال (MAIL FROM)',
    visibleSenderAddress: 'عنوان المرسل الظاهر',
    visibleSenderAddressHint: 'ما يراه المستقبِل — يُترك فارغًا ليكون هو بريد المرسل نفسه',

    host: 'عنوان خادم البريد',
    hostHint: 'عنوان خادم الإرسال، مثال: mail.domain.com',
    port: 'رقم المنفذ',
    portHint: 'غالبًا 587 أو 465',
    username: 'اسم المستخدم',
    usernameHint: 'البريد المستخدم لتسجيل الدخول إلى الخادم',
    password: 'كلمة المرور',
    passwordHint: 'كلمة مرور البريد المستخدم',
    passwordKeptHint: 'اتركها فارغة للإبقاء على كلمة المرور المحفوظة',

    connectionMethod: 'طريقة الإتصال',
    connectionMethodHint: 'نوع التشفير المستخدم في الاتصال',
    validateCertificate: 'التحقق من شهادة الخادم',
    validateCertificateHint: 'أوقف التحقق لخادم بشهادة موقّعة ذاتيًا',
    certificateDefault: 'الإعداد الافتراضي',
    certificateValidate: 'تحقق من الشهادة',
    certificateSkip: 'لا تتحقق من الشهادة',
    active: 'هذه الجهة مفعلة',
    activeHint: 'الجهات المفعلة فقط تظهر عند اختيار مرسل الحملة',

    test: 'اختبار الإرسال',
    testAddress: 'البريد المستخدم للاختبار',
  },

  /** صندوق البلاغات — إعدادات الوصول إلى الرسائل. */
  imapForm: {
    add: 'صندوق بريد جديد',
    edit: 'تعديل صندوق البريد',
    empty: 'لا توجد صناديق بريد بعد',
    deleteConfirm: 'هل تريد حذف صندوق البريد هذا؟',

    host: 'عنوان خادم البريد',
    hostHint: 'عنوان خادم الوصول إلى الرسائل، مثال: mail.domain.com',
    port: 'رقم المنفذ',
    portHint: 'غالبًا 993 للاتصال المشفر و143 لغيره',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    passwordHint: 'كلمة مرور البريد المستخدم',
    passwordKeptHint: 'اتركها فارغة للإبقاء على كلمة المرور المحفوظة',
    folderName: 'اسم المجلد',
    folderNameHint: 'المجلد الذي تُقرأ منه البلاغات، مثال: INBOX',
    connectionMethod: 'طريقة الإتصال',
    connectionMethodHint: 'نوع التشفير المستخدم في الاتصال',

    tls: 'تفعيل التشفير',
    tlsHint: 'يُستخدم مع طريقة الاتصال المختارة',
    deleteEmails: 'حذف رسائل الحملات بعد قراءتها',
    deleteEmailsHint: 'تُحذف رسالة البلاغ من الصندوق بعد احتسابها',
    active: 'هذا الصندوق مفعل',
    activeHint: 'الصندوق المفعل هو الذي تقرأ منه خدمة متابعة البريد',
    singleActiveNote: 'صندوق واحد فقط يمكن أن يكون مفعلًا — تفعيل هذا يوقف بقية الصناديق.',

    test: 'اختبار الاتصال',
  },

  tabs: {
    settings: 'إعدادات الإصطياد',
    categories: 'تصنيفات الإصطياد', // Resources.Phishing_Categories
    smtp: 'إعدادات ارسال البريد', // Resources.EmailSMTPSettings
    imap: 'إعدادات الوصول إلى الرسائل', // Resources.EmailIMAPSettings
    domains: 'الروابط', // Resources.Domains
  },

  categories: {
    name: 'الاسم بالعربية', // Resources.Arabic_Name_
    nameEn: 'الاسم بالإنجليزية', // Resources.English_Name_
    status: 'نشط', // Resources.IsActive
  },

  smtp: {
    senderName: 'إسم جهة الارسال', // Resources.SenderName
    host: 'الخادم', // Resources.Used_Email_Host
    port: 'رقم المنفذ', // Resources.Port
    from: 'بريد المرسل', // Resources.From
    username: 'اسم المستخدم', // Resources.Username
    status: 'نشط', // Resources.IsActive
  },

  imap: {
    host: 'الخادم', // Resources.Used_Email_Host
    port: 'رقم المنفذ', // Resources.Port
    username: 'اسم المستخدم', // Resources.Username
    folderName: 'اسم المجلد', // Resources.FolderName
    connectionMethod: 'طريقة الإتصال', // Resources.ConnectionMethod
    deleteEmails: 'حذف الرسائل بعد التعامل معها', // Resources.Delete_Campaigns_Emails
    status: 'نشط', // Resources.IsActive
    lastSync: 'آخر قراءة',
    neverSynced: 'لم تُقرأ بعد',
  },

  domains: {
    name: 'الإسم', // Resources.Name
    url: 'الرابط', // Resources.URL
  },

  deleteConfirm: 'هل تريد حذف هذا المدخل؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
}

/** تقارير الإصطياد — PhishingReport, both levels. */
export const reportStrings = {
  title: 'تقارير الإصطياد',
  subtitle: 'ما فعله المستهدفون بحملات الإصطياد',
  funnel: 'المسار',
  share: 'النسب',
  shareHint: 'من إجمالي المستهدفين',
  byCampaign: 'حسب الحملة',
  backToAll: 'كل الحملات',
  exportExcel: 'تصدير إلى إكسل',
  actionFailed: 'تعذر إتمام العملية',
  noCampaigns: 'لا توجد حملات',
  noUsers: 'لا يوجد مستهدفون في هذه الحملة',

  /* Said plainly because the field names mislead: the API's own counters do not mean what
     they appear to. */
  countingNote:
    'يُحتسب «أُرسلت» على عدد المستهدفين المسجّلين في الحملة بما فيهم من لم تُرسل إليهم بعد. و«فتح البريد» تراكمي يشمل من تجاوزه. و«فتح الرابط» لا يشمل من بلّغ عن الرسالة لاحقاً. و«بلّغ» يُحتسب من تاريخ التبليغ لا من الحالة.',

  stages: {
    sent: 'أُرسلت',
    opened: 'فتح البريد',
    clicked: 'فتح الرابط',
    submitted: 'أدخل بيانات',
    reported: 'بلّغ',
  },

  columns: {
    campaign: 'الحملة',
    startedOn: 'تاريخ البدء',
    status: 'الحالة',
    user: 'المستهدف',
    email: 'البريد الإلكتروني',
    department: 'الإدارة',
    phished: 'مرات إدخال البيانات',
    reportedOn: 'تاريخ التبليغ',
  },

  /** PhishingUserStatus — the scale the recipient rows arrive on, -1..4. */
  states: {
    '-1': 'مجدولة',
    [PHISHING_USER_STATUS.SENT]: 'أُرسلت',
    [PHISHING_USER_STATUS.EMAIL_OPENED]: 'فتح البريد',
    [PHISHING_USER_STATUS.LINK_CLICKED]: 'فتح الرابط',
    [PHISHING_USER_STATUS.DATA_SUBMITTED]: 'أدخل بيانات',
    [PHISHING_USER_STATUS.USER_REPORTED]: 'بلّغ',
  },
}
